import { render, staticRenderFns } from "./TooltipDecorator.vue?vue&type=template&id=9cb652d8&scoped=true&"
import script from "./TooltipDecorator.vue?vue&type=script&lang=ts&"
export * from "./TooltipDecorator.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipDecorator.vue?vue&type=style&index=0&id=9cb652d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb652d8",
  null
  
)

export default component.exports